import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Grid from "@material-ui/core/Grid";
import ICIPAdminService from "../../../../../services/ICIPAdminService";
import { NewRaffleDraw } from "../modals/NewRaffleDraw";
import { Box, TableRow } from "@material-ui/core";

import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../../../components/TableData";
import RaffleDraw from "../../../../../models/RaffleDraw";
import Button from "@material-ui/core/Button";
import { EditRaffleDraw } from "../modals/EditRaffleDraw";
import { EditSpecialRaffleDraw } from "../modals/EditSpecialRaffleDraw";
import moment from "moment";
import { NewSpecialRaffleDraw } from "../modals/NewSpecialRaffleDraw";
import Alert from "@material-ui/lab/Alert";
import CheckIcon from "@material-ui/icons/Check";

interface RaffleDrawListProps {}

const useStyles = makeStyles(() => ({
  tabHeading: {
    fontWeight: "bold",
    fontSize: 14,
  },
  newButton: {
    //textTransform: "none",
    fontSize: 13,
    margin: 5,
  },
  subButton: {
    textTransform: "none",
    fontSize: 10,
    padding: 2,
    margin: 2,
    width: 35,
  },
}));

export const RaffleDrawsList = (props: RaffleDrawListProps) => {
  //const intl = useIntl();
  const classes = useStyles();

  // State
  const [raffleDraws, setRaffleDraws] = useState([]);
  const [error, setError] = useState(false);
  const [notifyError, setNotifyError] = useState(false);
  const [succeed, setSucceed] = useState(false);
  const [raffleModalOpened, setRaffleModalOpened] = useState(false);
  const [specialRaffleModalOpened, setSpecialRaffleModalOpened] = useState(
    false
  );
  const [editRaffleModalOpened, setEditRaffleModalOpened] = useState(false);
  const [
    editSpecialRaffleModalOpened,
    setEditSpecialRaffleModalOpened,
  ] = useState(false);
  const [selectedRaffleDraw, setSelectedRaffleDraw] = useState(null);
  const [winningPackages, setWinningPackages] = useState([]);
  const [sendingSMS, setSendingSMS] = useState([]);
  const [sendingStartSMS, setSendingStartSMS] = useState([]);

  const toggleRaffleDrawModal = () => {
    setRaffleModalOpened(!raffleModalOpened);
  };

  const toggleSpecialRaffleDrawModal = () => {
    setSpecialRaffleModalOpened(!specialRaffleModalOpened);
  };

  const toggleEditRaffleDrawModal = () => {
    setEditRaffleModalOpened(!editRaffleModalOpened);
  };

  const toggleSpecialEditRaffleDrawModal = () => {
    setEditSpecialRaffleModalOpened(!editSpecialRaffleModalOpened);
  };

  const handleEditClick = (e, data) => {
    setSelectedRaffleDraw(data);

    if (data.raffle_draw_type === 0) {
      toggleSpecialEditRaffleDrawModal();
    } else {
      toggleEditRaffleDrawModal();
    }
  };

  const getWinningPackages = () => {
    ICIPAdminService.getWinningPackages().then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        const resultPackages = JSON.parse(JSON.stringify(response.data.data));
        setWinningPackages(resultPackages);
      }
    });
  };

  const fetchRafflesList = () => {
    ICIPAdminService.getRaffleDraws().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const raffleResults = JSON.parse(
              JSON.stringify(response.data.data)
            );
            setRaffleDraws(raffleResults);

            //Tab for checkik circular of differents notify button
            let sendingSMSTab = [];
            for (let i = 0; i < raffleResults.length; i++) {
              sendingSMSTab[i] = false;
            }
            setSendingSMS(sendingSMSTab);

            break;
          case 110:
            setError(true);
            break;
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  const sendRemindSMS = (raffleDrawId: number, index: number) => {
    let currentSendingSMS = [...sendingSMS];
    currentSendingSMS[index] = true;
    setSendingSMS(currentSendingSMS);

    ICIPAdminService.sendRemindSMS(raffleDrawId).then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            setSucceed(true);
            setTimeout(() => {
              setSucceed(false);
            }, 3000);
            break;
          case 102:
            setNotifyError(true);
            setTimeout(() => {
              setNotifyError(false);
            }, 3000);
            break;
        }
      } else {
        setNotifyError(true);
        setTimeout(() => {
          setNotifyError(false);
        }, 3000);
      }
      //setLoading(false);
      currentSendingSMS[index] = false;
      setSendingSMS(currentSendingSMS);
    });
  };

  const sendStartNotificationSMS = (raffleDrawId: number, index: number) => {
    let currentSendingStartSMS = [...sendingStartSMS];
    currentSendingStartSMS[index] = true;
    setSendingStartSMS(currentSendingStartSMS);

    ICIPAdminService.sendStartNotificationSMS(raffleDrawId).then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            setSucceed(true);
            setTimeout(() => {
              setSucceed(false);
            }, 3000);
            break;
          case 102:
            setNotifyError(true);
            setTimeout(() => {
              setNotifyError(false);
            }, 3000);
            break;
        }
      } else {
        setNotifyError(true);
        setTimeout(() => {
          setNotifyError(false);
        }, 3000);
      }
      //setLoading(false);
      currentSendingStartSMS[index] = false;
      setSendingStartSMS(currentSendingStartSMS);
    });
  };

  useEffect(() => {
    fetchRafflesList();
  }, []);

  useEffect(() => {
    getWinningPackages();
  }, []);

  // Renders

  const render = () => {
    return (
      <>
        {raffleModalOpened && (
          <NewRaffleDraw
            closeCallback={toggleRaffleDrawModal}
            onSubmitCallback={fetchRafflesList}
            isOpened={raffleModalOpened}
          />
        )}
        {specialRaffleModalOpened && (
          <NewSpecialRaffleDraw
            closeCallback={toggleSpecialRaffleDrawModal}
            onSubmitCallback={fetchRafflesList}
            isOpened={specialRaffleModalOpened}
          />
        )}
        {editRaffleModalOpened && (
          <EditRaffleDraw
            closeCallback={toggleEditRaffleDrawModal}
            onSubmitCallback={fetchRafflesList}
            isOpened={editRaffleModalOpened}
            raffleDraw={selectedRaffleDraw}
            packages={winningPackages}
          />
        )}
        {editSpecialRaffleModalOpened && (
          <EditSpecialRaffleDraw
            closeCallback={toggleSpecialEditRaffleDrawModal}
            onSubmitCallback={fetchRafflesList}
            isOpened={editSpecialRaffleModalOpened}
            raffleDraw={selectedRaffleDraw}
          />
        )}
        <Box component="div">
          <Grid container alignItems="flex-start" item xs={12} lg={12}>
            {succeed && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="success">
                  <FormattedMessage id="sharedScreen.smsNotificationSendSuccess" />
                </Alert>
              </Grid>
            )}
            {notifyError && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="error">
                  <FormattedMessage id="sharedScreen.errorWhileSendingSMS" />
                </Alert>
              </Grid>
            )}
            <Grid container item xs={6} lg={6}>
              <Button
                color="secondary"
                variant="contained"
                className={classes.newButton}
                onClick={toggleRaffleDrawModal}
              >
                <FormattedMessage id="sharedScreen.newRaffleDraw" />
              </Button>

              <Button
                color="secondary"
                variant="contained"
                className={classes.newButton}
                onClick={toggleSpecialRaffleDrawModal}
              >
                <FormattedMessage id="sharedScreen.newSpecialRaffleDraw" />
              </Button>
            </Grid>
          </Grid>

          <TableData
            rows={renderRafflesTableRows()}
            header={renderRafflesTableHeader()}
          />
        </Box>
      </>
    );
  };

  const renderRafflesTableRows = () => {
    return raffleDraws.map((row, index) => {
      let raffleDraw = row as RaffleDraw;
      let raffleDrawId = row.id;

      return (
        <StyledTableRow key={index}>
          <StyledTableCell component="td" scope="row">
            {raffleDraw.raffle_draw_type ? <p> NORMAL </p> : <p> SPECIAL </p>}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {raffleDraw.renew_losers ? <p> YES </p> : <p> NO </p>}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {raffleDraw.number_of_winners}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {moment
              .utc(raffleDraw.raffle_draw_date)
              .local()
              .format("YYYY-MM-DD HH:mm:ss")}
            {raffleDraw.in_progress && <CheckIcon color="secondary" />}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {raffleDraw.ended_at}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            <Button
              color="secondary"
              variant="contained"
              className={classes.subButton}
              value={raffleDraw.id}
              onClick={(e) => handleEditClick(e, raffleDraw)}
            >
              Edit
            </Button>
            <Button
              color="secondary"
              variant="contained"
              className={classes.subButton}
              value={raffleDraw.id}
              onClick={(e) => sendRemindSMS(raffleDrawId, index)}
            >
              <FormattedMessage id="sharedScreen.remindParticipants" />
              {sendingSMS[index] && (
                <CircularProgress color="inherit" size={20} />
              )}
            </Button>
            <Button
              color="secondary"
              variant="contained"
              className={classes.subButton}
              value={raffleDraw.id}
              onClick={(e) => sendStartNotificationSMS(raffleDrawId, index)}
            >
              <FormattedMessage id="sharedScreen.startRaffleDrawNotif" />
              {sendingStartSMS[index] && (
                <CircularProgress color="inherit" size={20} />
              )}
            </Button>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  };

  const renderRafflesTableHeader = () => {
    return (
      <TableRow>
        <StyledTableCell className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.raffleDrawType" />
        </StyledTableCell>
        <StyledTableCell className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.RaffleDrawRenewLosers" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.RaffleDrawNumberOfWinners" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.raffleDrawDate" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.RaffleDrawEndedAt" />
        </StyledTableCell>
        <StyledTableCell align="left" className={classes.tabHeading}>
          <FormattedMessage id="sharedScreen.actions" />
        </StyledTableCell>
      </TableRow>
    );
  };

  return (
    <>
      <Box component="div">
        <Box component="div">
          <Box component="div">
            <Box component="div">{render()}</Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
